var map = {
	"./D-F.jpg": 4784,
	"./G-J.jpg": 2515,
	"./I1.jpg": 3815,
	"./I2.jpg": 9115,
	"./I3.jpg": 9109,
	"./IF.jpg": 1260,
	"./K-M.jpg": 9604,
	"./N-R.jpg": 1826,
	"./S-Z.jpg": 1127,
	"./SI1-nuevo.jpg": 5358,
	"./SI2.jpg": 4243,
	"./VS1.jpg": 9587,
	"./VS2.jpg": 9876,
	"./WS1.jpg": 7598,
	"./WS2.jpg": 3545,
	"./brillante.jpg": 3856,
	"./corazon.jpg": 7091,
	"./esmeralda.jpg": 7227,
	"./g-h-i.jpg": 2195,
	"./j-k-l-m.jpg": 4726,
	"./marquise.jpg": 7266,
	"./n-o-p-q-r-s-t-u-v-w-x-y-z.jpg": 2643,
	"./oval.jpg": 813,
	"./pera.jpg": 8759,
	"./si1.jpg": 4,
	"./si2, si3.jpg": 384,
	"./vs1, vs2.jpg": 2146,
	"./vvs1, vvs2.jpg": 8002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6410;